import React from 'react';
import { Legend, Line, LineChart, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts';
import PropTypes from 'prop-types';
import { showValueWithCurrency } from '@/utils/utils';
import { COLOR_CANTIDAD_PAGOS, COLOR_IMPORTE } from '@/modules/dashboard/constants/colors';
import moment from 'moment';

const HistogramPagosPorFecha = ({ data = [] }) => {
  const hasData = data?.some(item => item.count > 0);
  
  return (
    <ResponsiveContainer width="100%" height={350}>
      <LineChart
        data={hasData ? data : [{ name: 'Sin datos', count: 0, total: 0, _id: moment().format('LL') }]}
        margin={{ top: 20, right: 30, left: 40, bottom: 40 }}
      >
        <YAxis />
        <XAxis
          dataKey="_id"
          angle={!hasData ? 0 : 45}
          max={20}
          textAnchor="start"
          height={60}
          interval={2}
        />
        <Tooltip
          formatter={(value, name) => name === 'Importe' ? showValueWithCurrency(value || '0') : value}
          labelFormatter={label => `Fecha: ${label}`}
        />
        <Legend
          formatter={value =>
            value === 'count'
              ? 'Cantidad de pagos'
              : value === 'total'
                ? 'Importe'
                : value
          }
        />
        <Line
          type="monotone"
          dataKey="count"
          stroke={COLOR_CANTIDAD_PAGOS}
          name="Cantidad de pagos"
          dot
          activeDot={{ r: 6 }}
        />
        <Line
          type="monotone"
          dataKey="total"
          stroke={COLOR_IMPORTE}
          name="Importe"
          dot
          activeDot={{ r: 6 }}
        />
      </LineChart>
    </ResponsiveContainer>
  );
};

HistogramPagosPorFecha.propTypes = {
  data: PropTypes.array,
};

export default HistogramPagosPorFecha;
